<template>
  <div>
    <v-row no-gutters>
      <v-col 
        align-self="center"
        cols="1"
      >
        <v-btn
          class="mr-5 ml-1"
          icon
          @click="clickPlay"
        >
          <v-icon>
            {{ playInterval ? 'mdi-pause' : 'mdi-play' }}
          </v-icon>
        </v-btn>
      </v-col>
      <v-col 
        cols="10"
        class="d-flex justify-center"
      >
        <v-slide-group 
          class="justify-center"
          show-arrows="always"
        >
          <template #prev>
            <v-card 
              width="min-content"
              class="ma-2 mr-n4"
            >
              <v-icon class="py-2 black--text">
                mdi-chevron-left
              </v-icon>
            </v-card>
          </template>
          <v-slide-item 
            v-for="item of steps"
            :key="`step-${item}`"
          >
            <v-card 
              class="ma-2"
              :style="{transition: 'background-color 0.2s ease-in-out'}"
              :class="{'primary lighten-2': value == item}"
              @click="$emit('input', parseInt(item))"
            >
              <div class="font-weight-bold pa-2">
                {{ minutesToDisplay(item) }}
              </div>
            </v-card>
          </v-slide-item>
          <template #next>
            <v-card 
              width="min-content"
              class="ma-2 ml-n4"
            >
              <v-icon class="py-2 black--text">
                mdi-chevron-right
              </v-icon>
            </v-card>
          </template>
        </v-slide-group>
      </v-col>
      <v-spacer />
    </v-row>
    <!-- <time-radar-slider 
      :value="value"
      :step="step"
      :min="min"
      :max="max"
      :prepend-icon="!!playInterval ? 'mdi-pause' : 'mdi-play'"
      @click:prepend="clickPlay"
      @input="(value) => {
        $emit('input', value)
        $emit('change')
      }"
      @mousedown="resetPlayInterval"
    /> -->
  </div>
</template>

<script>
// import TimeRadarSlider from './helperComponents/TimeRadarSlider'
import floorPlanTimeHelpers from './mixins/floorPlanTimeHelpers'
export default {
  name: 'TimeRadar',
  // components: {TimeRadarSlider},
  mixins: [floorPlanTimeHelpers],
  props: {
    value: {
      type: [Number, String],
      validator (value) {return !isNaN(value)}
    },
    steps: {
      type: Array,
      required: true
    },
    mealPeriod: {
      type: Object,
      default () {return {}}
    }
  },
  data () {
    return {
      playInterval: undefined,
    }
  },
  watch: {
    mealPeriod: {
      handler () {
        this.resetPlayInterval()
      },
      deep: true
    }
  },
  methods: {
    clickPlay () {
      if (this.playInterval) {
        clearInterval(this.playInterval)
        this.playInterval = undefined
      } else {
        this.playInterval = setInterval(() => {
          const index = this.steps.findIndex(e => e == this.value) ?? -1
          if (index !== this.steps.length - 1) {
            this.$emit('input', this.steps[index + 1] ?? this.steps[0])
            this.$emit('change')
          } else {
            this.resetPlayInterval()
          }
        }, 2000)
      }
    },
    resetPlayInterval () {
      if (this.playInterval) {
        clearInterval(this.playInterval)
        this.playInterval = undefined
      }
    }
  }
}
</script>

<style scoped>
.v-card::before {
  background: none;
}
.v-slide-group__next--disabled div, .v-slide-group__prev--disabled div {
  display: none;
}
.v-slide-group__content {
  justify-content: center;
}
</style>